/**
 * Check buttons list component script
 */
export const ProfilePicWideWControls = (function () {

  var init = function () {

    $(".profile-pic-remove").off('click').on("click", function () {
      var key = $(this).attr("key");
      
      $.post(
        MaMFormHandler.getBaseUrl()+"/remove-profile-pic",
        {
          key: key,
        },
        function (res) {
          console.log(res);
        },
        "json"
      );

      if($(this).closest('.append-gallery-results').hasClass('no-gallery-mode')){
        var containerKey = $('#profile-pic-key').val();
        $("#profile-pic-upload-container-" + containerKey).removeClass("d-none");
      }

      $("#profile-pic-container-" + key).addClass("d-none");
    });

  };
  

  return {
    init: init
  };
})();
